import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("修改")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { ElMessage } from 'element-plus'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { 
  'GET/salaries/exchange_rate/page': fetchList,
  // 修改汇率
  'POST/salaries/exchange_rate/update': exchange_rateUpdateApi,
 } = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm 
} = new tbMix(fetchList)
fetchData()




const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  {
    type: 'NUMBER',
    label: '汇率',
    value: '',
    upKey: 'exchangeRate',
    rule: [ { required: true, message: '请输入汇率', trigger: 'change' }]
  },
])
const modifyHandle = (row: object) => {
  MI_modifyForm(row, modifyConfig, modifyFg, async (params: object) => {
    await exchange_rateUpdateApi({...row, ...params})
    ElMessage.success('修改成功')
    modifyFg.value = false
    fetchData()
    
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "月份",
          prop: "month"
        }),
        _createVNode(_component_el_table_column, {
          label: "汇率",
          prop: "exchangeRate"
        }),
        _createVNode(_component_el_table_column, {
          label: "更新时间",
          prop: "updatedAt"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (modifyHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50 ],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "修改汇率",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})